import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
  compose,
  setDisplayName,
} from 'recompose';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import { withTracker } from 'components/Tracker';
import {injectIntl } from 'components';
import immutableToJS from 'helpers/immutableToJS';

const styles = () => ({
  acceptBtn: {},
  activeItemText: {
    color: 'inherit',
    fontSize: '0.925rem',
    fontWeight: 500,
    lineHeight: '1.4em',
  },
  item: { padding: '15px 16px 15px 24px' },
  listItemText: { paddingLeft: 0 },
  nestedItem: { padding: '16px 10px 16px 40px' },
  nestedList: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    padding: 0,
  },
  normalItemText: {
    color: 'inherit',
    fontSize: '0.925rem',
    fontWeight: 300,
    lineHeight: '1.4em',
  },
  notificationBadge: {
    backgroundColor: '#ff602e',
    right: 10,
    top: -13,
  },
});

export class HomeSidebar extends Component {
  static contextTypes = {
    brands: PropTypes.shape({}),
    isConsumer: PropTypes.bool,
  };

  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    sidebarOpen: PropTypes.bool,
    toggleDrawer: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }),
  };

  state = {
    open :this.props.sidebarOpen || false,
  };

  componentWillReceiveProps({ sidebarOpen }) {
    this.setState({ open: sidebarOpen });
  }

  render() {
    const {
      toggleDrawer,
      history,
    } = this.props;
    const { open } = this.state;
    const { brands } = this.context;
    return (
      <Drawer
        className="sidebar"
        classes={{ paper: 'nav-sidebar-container' }}
        onClose={toggleDrawer(false)}
        open={open}
      >
       <div className="nav-logo" style={{margin: 'auto'}}>
          <img
            alt="sun"
            className="logo"
            src={brands.logoUrl}
            style={{ height: '25px', marginTop: '15%'}}
          />
        </div>
        <List className="sidebar-list">
            <Divider />
            <ListItem button key={"farms"}  onClick={ () => {history.push('/features?category=farm')}} >
                <ListItemText primary={"Farms"} />
            </ListItem>
            <ListItem button key={"distributors"} onClick={ () => {history.push('/features?category=distributor')}} >
                <ListItemText primary={"Distributors"} />
            </ListItem>
            <ListItem button key={"restaurants"} onClick={ () => {history.push('/features?category=restaurant')}} >
                <ListItemText primary={"Restaurants"} />
            </ListItem>
            <Divider />
        </List>
      </Drawer>
    );
  }
}




export default compose(
  setDisplayName('HomeSidebar'),
  withStyles(styles),
  immutableToJS,
  injectIntl,
  withTracker,
  withRouter,
)(HomeSidebar);

